import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * 🔓 QZ Tray Public Certificate State
 * ------------------------------------------------------------
 * Maneja únicamente el certificado público (cert.pem) necesario
 * para inicializar la conexión segura con QZ Tray.
 */
export interface QzTrayPublicCertificateState {
  /** 📜 Certificado público en formato PEM */
  certificate: string | null;

  /** ⏳ Estado de carga (petición en proceso) */
  isLoading: boolean;

  /** ⚠️ Error si ocurre */
  error: string | null;
}

const initialState: QzTrayPublicCertificateState = {
  certificate: null,
  isLoading: false,
  error: null,
};

const qzTrayPublicCertificateSlice = createSlice({
  name: "qzTrayPublicCertificate",
  initialState,
  reducers: {
    // 🔄 Cargando
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    // 📜 Guardar certificado
    setCertificate(state, action: PayloadAction<string | null>) {
      state.certificate = action.payload;
      state.error = null;
    },

    // ❌ Error
    setCertificateError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },

    // 🧹 Reset
    resetPublicCertificateState() {
      return initialState;
    },
  },
});

export const {
  setLoading,
  setCertificate,
  setCertificateError,
  resetPublicCertificateState,
} = qzTrayPublicCertificateSlice.actions;

export default qzTrayPublicCertificateSlice.reducer;
